module.exports = __webpack_public_path__ + "static/media/homeGrey.168f6a52.svg";